import { IHeader, ITheme } from 'survey-core';

/* eslint-disable no-unused-vars */
export enum SubmissionStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  IN_PROGRESS = 'IN_PROGRESS',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  AWAITING_SIGNATURE = 'AWAITING_SIGNATURE',
  AWAITING_TRADE_REFERENCES = 'AWAITING_TRADE_REFERENCES',
  SUBMITTED = 'SUBMITTED',
}
/* eslint-enable no-unused-vars */

/* eslint-disable no-unused-vars */
export enum UserType {
  INITIAL_USER = 'initial-user',
  SIGNER = 'signer',
}
/* eslint-enable no-unused-vars */

export const SIGNED_SUBMISSION_STATUSES = new Set([
  SubmissionStatus.READY_FOR_REVIEW,
  SubmissionStatus.APPROVED,
  SubmissionStatus.REJECTED,
  SubmissionStatus.AWAITING_TRADE_REFERENCES,
  SubmissionStatus.SUBMITTED,
]);

export type SurveyQuestion = {
  type: string;
  name: string;
  title?: string;
  description?: string;
  html?: string;
  isRequired?: boolean;
  inputType?: string;
  startWithNewLine?: boolean;
  choices?: string[];
  showOtherItem?: boolean;
}

export type SurveyPage = {
  title: string;
  description?: string;
  name?: string;
  elements: SurveyQuestion[];
}

export type Survey = {
  title: string;
  pages: SurveyPage[];
  header?: IHeader;
  headerView?: 'basic' | 'advanced';
};

export type SurveyColors = {
  header: string;
  sidebar: string;
}

export type SurveyTheme = {
  logoUrl: string;
  colors: SurveyColors;
};

export type SurveySettings = {
  urlSlug: string;
  survey: Survey;
  tradeReferenceSurvey?: Survey;
  theme: SurveyTheme;
  surveysTheme?: ITheme;
  entityName?: string;
};

export type Signer = {
  email: string;
  isInitialUser: boolean;
  isVerified: boolean;
};

export interface Submission {
  publicId: string;
  details?: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    company: string;
    role: string;
    department: string;
  };
  responses: Record<string, unknown>;
  status: SubmissionStatus;
  signer?: Signer;
}

export type StatusMessage = {
  severity: 'error' | 'warning' | 'info' | 'success';
  message: string;
  messageInstanceId?: number;
};

export interface TokenExpirationMessageProps {
  publicId: string;
  slug: string;
  currentToken?: string;
}

export interface EmailConfirmationMessageProps {
  publicId: string;
  slug: string;
}
